import Alpine from "alpinejs";

Alpine.data('clearFiltersButton', () => ({
  get url() {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q');
    return query ? `${window.location.pathname}?q=${query}` : window.location.pathname;
  },
}));